import { Roles } from '@/utils/roles';
import { FeaturesEnum } from '@utils/features';
import { pathJoin } from '../paths';
import { resolvePathRoute } from '../generate-route';
import { ReservationListPage, ViewReservationPage } from '../elements';

const ROOT = 'reservations';
export const paths = (root: string): any => ({
  root: {
    path: pathJoin(root, [ROOT]),
    title: ROOT,
    onlyOption: true,
    isFoodCompany: true,
    guard: [Roles.ADMIN, Roles.ATM],
    feature: FeaturesEnum.RESERVATIONS,
  },
  list: {
    path: pathJoin(root, [ROOT, 'list']),
    element: ReservationListPage,
    params: undefined,
    title: 'list',
    show: true,
    feature: FeaturesEnum.RESERVATIONS_LIST,
  },
  view: {
    path: (name: string) => pathJoin(root, [ROOT, name]),
    element: ViewReservationPage,
    params: ':id',
    feature: FeaturesEnum.RESERVATIONS_VIEW,
  },
});

export const pathReservations = (root: string) => ({
  [ROOT]: resolvePathRoute(paths(root)),
});
